import React from 'react';

const StrategyHelpPopover = ({ label = 'What does this mean?', children }) => (
  <details className="mt-2 rounded-lg border border-slate-200 bg-white/70 p-2 text-xs dark:border-slate-700 dark:bg-slate-950/40">
    <summary className="min-h-11 cursor-pointer py-2 font-bold text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 dark:text-blue-300">
      {label}
    </summary>
    <p className="pb-2 leading-5 text-slate-600 dark:text-slate-300">{children}</p>
  </details>
);

export default StrategyHelpPopover;
